import ApprovalHeading from './ApprovalHeading';
import ApprovalStatusDot from './ApprovalStatusDot';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApprovalSidebarStatusHeading = () => {
  return /*#__PURE__*/_jsxs(TFlex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(ApprovalStatusDot, {}), /*#__PURE__*/_jsx(ApprovalHeading, {})]
  });
};
export default ApprovalSidebarStatusHeading;